module.exports = __webpack_public_path__ + "img/Aura_magic.66094cb9.png";